import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { selectDataAvailabilityDetails } from '../../../../../common/order/factSheetReport/store/slice'
import { convertParamSettingFs } from '../helper'
import classes from '../index.module.scss'
import {
  changeAllCurrencyUnitFs,
  changeSettingFs,
  setDefaultYearFinancialAnalysis,
} from '../store/slice'

const GroupButton = ({ handleClose, currencyUnit }) => {
  const dispatch = useDispatch()

  const dataAvailability = useSelector(selectDataAvailabilityDetails)

  const handleSubmit = () => {
    dispatch(changeAllCurrencyUnitFs(currencyUnit))
    dispatch(changeSettingFs(convertParamSettingFs(dataAvailability)))
    dispatch(setDefaultYearFinancialAnalysis(dataAvailability))
    handleClose()
  }

  const isDisabled = !dataAvailability?.length

  return (
    <div className={`${classes.mt12} dFlex justifyContentEnd`}>
      <Element
        className={classes.btnSettingFs}
        style={{ backgroundColor: '#FFFFFF', border: '1px solid #D5D5D5' }}
        onClick={handleClose}
      >
        <Translate value="common.CANCEL" />
      </Element>
      <Element
        className={classes.btnSettingFs}
        style={{
          backgroundColor: '#2C73E8',
          border: '1px solid #2C73E8',
          color: '#FFFFFF',
          opacity: isDisabled ? 0.4 : 1,
        }}
        onClick={!isDisabled ? handleSubmit : undefined}
      >
        OK
      </Element>
    </div>
  )
}

export default GroupButton
